import React from 'react';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
  Button,
  ContentTemplate,
  Grid,
  KeyValue,
  Link,
  Progress,
  SectionHeader,
  Theme as AugmentedTheme,
  TitleHeader,
  Typography,
} from 'web-library';
import { candidateService } from '../../api';
import { stringToLongDateAndShortTime } from '../../utils/DateUtils';
import RouteKey from '../../routes/key';
import { useWOGAA } from '../../hooks/wogaa';

const { root, summary, coordinatorRoot, coordinatorSummary } = RouteKey['access-arrangement'].child;
const { accessArrangement } = RouteKey.child;

const useStyles = makeStyles()((theme) =>
({
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(2),
  },
}));

const SubmittedPage = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();

  const {
    data,
    isLoading,
  } = candidateService.accessArrangement.candidate.useGetAppealArrangementRequestAcknowledgement(
    uuid
  );

  const role = window.location.pathname.includes('coordinator') ? 'coordinator' : 'candidate';
 // wogaa aa and aa amedment end for candidate & coordinator
  const { transactionEnd } = useWOGAA('myexamsseab-6465');
  const { transactionEnd: transactionEndAmendment } = useWOGAA('myexamsseab-6466');
  const { transactionEnd: transactionEndCoordinator } = useWOGAA('myexamsseab-6467');
  const { transactionEnd: transactionEndCoordinatorAmendment } = useWOGAA('myexamsseab-6468');
  transactionEnd(uuid);
  transactionEndAmendment(uuid);
  transactionEndCoordinator(uuid);
  transactionEndCoordinatorAmendment(uuid);

  const handleViewFullSummaryClick = () => {
    if (role === 'candidate') {
      history.push(`/${accessArrangement}/${root.route}/${summary.route}/${uuid}`);
    } else {
      history.push(
        `/${accessArrangement}/${coordinatorRoot.route}/${coordinatorSummary.route}/${uuid}`
      );
    }
  };

  const handleBackToApplicationClick = () => {
    if (role === 'candidate') {
      history.push(`/${accessArrangement}/${root.route}`);
    } else {
      history.push(`/${accessArrangement}/${coordinatorRoot.route}`);
    }
  };

  if (isLoading) {
    return (
      <ContentTemplate>
        <Progress color="secondary" />
      </ContentTemplate>
    );
  }

  return (
    <>
      <TitleHeader state="success" title={t('accessArrangement->>AppealReceipt.SubmittedAppeal')} />
      <ContentTemplate>
        <Grid container>
          <Grid xs={12}>
            <SectionHeader
              title={t('accessArrangement->>AppealReceipt.FormHeader')}
            >
                <Link id="link-viewFullSummary" onClick={handleViewFullSummaryClick}>
                  <Typography variant="h5">
                    {t('accessArrangement->>AppealReceipt.ViewFullSummary')}
                  </Typography>
                </Link>

            </SectionHeader>
          </Grid>
        </Grid>
        <Grid container>
          <Grid xs={12}>
            <KeyValue
              id="transactionNo"
              keyText={t('accessArrangement->>AppealReceipt.ApplicationID')}
              valueText={data?.applicationId}
            />
          </Grid>
          <Grid xs={12}>
            <KeyValue
              keyText={t('accessArrangement->>AppealReceipt.ApplicationDateTime')}
              valueText={stringToLongDateAndShortTime(data?.applicationDateTime ?? '')}
            />
          </Grid>
        </Grid>
        <Button
          id="button-resitReceipt-goToRegisteredExams"
          className={classes.button}
          onClick={handleBackToApplicationClick}
        >
          {t('accessArrangement->>AppealReceipt.BackToAppealApplications')}
        </Button>
      </ContentTemplate>
    </>
  );
};

export default SubmittedPage;
